import {Component, Input} from '@angular/core';

import {SimpleWord} from '../../models/simple-word.model';
import {VoiceService} from '../../services/voice/voice.service';

@Component({
  selector: 'app-word-play-btn',
  styleUrls: ['./word-play-btn.component.scss'],
  template: `
    <button type="button"
            *ngIf="word && word.wordVoice"
            class="sound-btn {{ on ? 'on' : '' }}"
            (click)="playSound($event)"></button>
  `,
})
export class WordPlayBtnComponent {
  @Input() word: SimpleWord;

  constructor(protected voice: VoiceService) {
  }

  public playSound(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    if (this.word) {
      if (this.on) {
        this.voice.Stop();
      } else {
        this.voice.PlaySound(this.word).subscribe();
      }
    }
  }

  public get on(): boolean {
    return this.voice.on && this.voice.wordId === this.word.id && this.voice.noEx === null;
  }
}
